import React from 'react';
import withIcon from '../utilities/withIcon';

const IconVariable = () => {
  return (
    <g>
      <path d="m5.8438 2.125a.75.75 0 0 0 0-1.5h-3.8125a.75.75 0 0 0 -.75.75v13.25a.75.75 0 0 0 .75.75h3.8125a.75.75 0 0 0 0-1.5h-3.0625v-11.75z" />
      <path d="m13.9688.625h-3.8125a.75.75 0 0 0 0 1.5h3.0625v11.75h-3.0625a.75.75 0 0 0 0 1.5h3.8125a.75.75 0 0 0 .75-.75v-13.25a.75.75 0 0 0 -.75-.75z" />
    </g>
  );
};

export default withIcon(IconVariable);
